// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/user-profile-pgs/icons/ellipse.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-pg-header {
  background-color: var(--cPink);
  height: 390px;
}

.txt-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 90%);
}

.ac-header-text h1 {
  font-size: 55px;
  font-weight: 700;
  color: var(--dBlue);
}

.signOutBtn {
  background-color: var(--dBlue);
  border-radius: 50px;
  width: 55%;
  padding: 12px;
  font-weight: 700;
  margin-top: 20px;
}

.ecllipse {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 350px;
  width: 475px;
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, 11%);
}

.user-img img {
  height: 350px;
  width: 350px;
}

@media (max-width: 1024px) {
  .txt-btn {
    text-align: center;
    transform: translate(-50%, 10%);
  }

  .signOutBtn {
    margin: 0;
    margin: initial;
  }

  .ecllipse {
    height: auto;
    width: 40%;
    transform: translate(-50%, 64%);
  }
  .ecllipse img {
    height: auto;
    width: 70%;
  }
}

@media (max-width: 767px) {
  .ecllipse {
    height: auto;
    width: 100%;
    margin-top: 10%;
    background-size: cover;
    transform: translate(-50%, -1%);
  }

  .user-img img {
    height: 230px;
    width: 230px;
  }

  .txt-btn {
    position: static;
    position: initial;
    transform: none;
    transform: initial;
    text-align: center;
  }

  .ac-header-text h1 {
    font-size: 45px;
    margin-top: 5%;
  }

  .signOutBtn {
    margin-top: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/common/account-pgs-header/AcPageHeader.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yDAAqF;EACrF,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,SAAa;IAAb,eAAa;EACf;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,+BAA+B;EACjC;EACA;IACE,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,gBAAe;IAAf,iBAAe;IACf,eAAgB;IAAhB,kBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".account-pg-header {\n  background-color: var(--cPink);\n  height: 390px;\n}\n\n.txt-btn {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, 90%);\n}\n\n.ac-header-text h1 {\n  font-size: 55px;\n  font-weight: 700;\n  color: var(--dBlue);\n}\n\n.signOutBtn {\n  background-color: var(--dBlue);\n  border-radius: 50px;\n  width: 55%;\n  padding: 12px;\n  font-weight: 700;\n  margin-top: 20px;\n}\n\n.ecllipse {\n  background-image: url(\"../../../../public/images/user-profile-pgs/icons/ellipse.png\");\n  height: 350px;\n  width: 475px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  position: absolute;\n  top: 0%;\n  left: 50%;\n  transform: translate(-50%, 11%);\n}\n\n.user-img img {\n  height: 350px;\n  width: 350px;\n}\n\n@media (max-width: 1024px) {\n  .txt-btn {\n    text-align: center;\n    transform: translate(-50%, 10%);\n  }\n\n  .signOutBtn {\n    margin: unset;\n  }\n\n  .ecllipse {\n    height: auto;\n    width: 40%;\n    transform: translate(-50%, 64%);\n  }\n  .ecllipse img {\n    height: auto;\n    width: 70%;\n  }\n}\n\n@media (max-width: 767px) {\n  .ecllipse {\n    height: auto;\n    width: 100%;\n    margin-top: 10%;\n    background-size: cover;\n    transform: translate(-50%, -1%);\n  }\n\n  .user-img img {\n    height: 230px;\n    width: 230px;\n  }\n\n  .txt-btn {\n    position: unset;\n    transform: unset;\n    text-align: center;\n  }\n\n  .ac-header-text h1 {\n    font-size: 45px;\n    margin-top: 5%;\n  }\n\n  .signOutBtn {\n    margin-top: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
